export default __webpack_public_path__ + "static/media/sunsculpted12.dcdce991.jpg";